import PropTypes from 'prop-types'

const Button = ({ idCenario, text, onClick }) => {
    
    return (
        <>
        {idCenario===0 && <button onClick={onClick} className='ripple'> {text} </button>}
        {idCenario===1 && <button1 onClick={onClick} className='ripple1'> {text} </button1>}
        {idCenario===2 && <button2 onClick={onClick} className='ripple2'> {text} </button2>}
        </>
    )
}

Button.defaultProps = {
    color: 'white'
}

Button.propTypes = {
    text: PropTypes.string,
    color: PropTypes.string,
    onClick: PropTypes.func,
}

export default Button